import { BulkUpdateSaleLotModalProps } from "components/BulkUpdateOptionalFieldsModal/types";
import React, { useMemo } from "react";
import { BulkUpdateOptionalFieldsModal } from "components/BulkUpdateOptionalFieldsModal/Modal";
import { bulkUpdateSaleLotsActionCreator } from "actions";
import {
  clearingSaleGeneralFields,
  clearingSaleIntegrationsFields,
} from "components/BulkUpdateOptionalFieldsModal/ClearingSaleLots/Fields";
import { validationSchema } from "components/BulkUpdateOptionalFieldsModal/ClearingSaleLots/ValidationSchema";
import { useSelector } from "react-redux";
import {
  getContextByModalType,
  getSaleLots,
  getSetting,
  selectDeploymentIdBySaleLotIdLookup,
} from "selectors";
import { ModalTypes } from "constants/navigation";
import { ModelNames } from "components/BulkUpdateOptionalFieldsModal/util";

const bulkUpdateFields = [
  ...clearingSaleGeneralFields,
  ...clearingSaleIntegrationsFields,
];

export function BulkUpdateClearingSaleSaleLotsModal(
  props: BulkUpdateSaleLotModalProps,
): React.JSX.Element {
  const { onClose } = props;

  const { saleLotIds, storedSaleLotIdsSetting, aggridRef } =
    useSelector(
      getContextByModalType(ModalTypes.BulkUpdateClearingSaleSaleLot),
    ) || {};

  const storedSaleLotIds =
    useSelector(getSetting(storedSaleLotIdsSetting)) || null;

  const modelIds = saleLotIds || storedSaleLotIds;

  const saleLots = useSelector(getSaleLots);
  const deploymentSaleIdLookup = useSelector(
    selectDeploymentIdBySaleLotIdLookup,
  );

  const deploymentId = useMemo(() => {
    // Coalesce each lookup to null. A missing lookup entry must not count
    // as its own distinct (undefined) value. Otherwise an unrelated lookup
    // miss could mask a single resolvable deployment.
    const resolvedDeploymentIds = (modelIds || [])
      .filter(modelId => saleLots[modelId])
      .map(modelId => deploymentSaleIdLookup[modelId] ?? null);

    const [firstDeploymentId] = resolvedDeploymentIds;
    const isSingleDeployment = resolvedDeploymentIds.every(
      id => id === firstDeploymentId,
    );

    return isSingleDeployment ? (firstDeploymentId ?? null) : null;
  }, [modelIds, saleLots, deploymentSaleIdLookup]);

  return (
    <BulkUpdateOptionalFieldsModal
      onClose={onClose}
      modelIds={modelIds}
      modelName={ModelNames.SALE_LOT}
      bulkUpdateActionCreator={bulkUpdateSaleLotsActionCreator}
      fields={bulkUpdateFields}
      initialValues={{}}
      modelObjects={saleLots}
      validationSchema={validationSchema}
      aggridRef={aggridRef}
      deploymentId={deploymentId}
    />
  );
}
